import { client } from 'app/http';

export const cancelSubscription = async (billingAccountId: string, subscriptionId: string) => {
  const { data } = await client.delete(`/billing-account/${billingAccountId}/subscription/${subscriptionId}`);
  return data;
};
